// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPageBrand_container__ivlvp","logo":"LandingPageBrand_logo__zTfFt","title":"LandingPageBrand_title__50T2D"};